module.exports = __webpack_public_path__ + "img/icon-WAIT-AUDIT.21b3fc0d.png";